module.exports = __webpack_public_path__ + "static/media/IMG-31.8bd7cb2c.jpg";